export type Permission = "AccessControl/TeamRole/assign/allUserInvitations/allTeams"
    | "AccessControl/TeamRole/assign/allUsers/allTeams"
    | "AccessControl/TeamRole/assign/allUsers/currentTeam"
    | "AccessControl/TeamRole/assign/allUsers/teamsOfUser"
    | "AccessControl/TeamRole/assign/userInvitationsCreatedByCurrentUser/allTeams"
    | "AccessControl/TeamRole/assign/userInvitationsCreatedByCurrentUser/currentTeam"
    | "AccessControl/TeamRole/assign/usersInCurrentTeam/currentTeam"
    | "AccessControl/TeamRole/retract/allUserInvitations/allTeams"
    | "AccessControl/TeamRole/retract/allUsers/allTeams"
    | "AccessControl/TeamRole/retract/allUsers/currentTeam"
    | "AccessControl/TeamRole/retract/userInvitationsCreatedByCurrentUser/allTeams"
    | "AccessControl/TeamRole/retract/userInvitationsCreatedByCurrentUser/currentTeam"
    | "AccessControl/TeamRole/retractAll/allUsers/allTeams"
    | "AccessControl/TeamRole/retractAll/allUsers/currentTeam"
    | "AccessControl/UserRole/assign/allUserInvitations"
    | "AccessControl/UserRole/assign/allUsers"
    | "AccessControl/UserRole/assign/userInvitationsCreatedByCurrentUser"
    | "AccessControl/UserRole/retract/allUserInvitations"
    | "AccessControl/UserRole/retract/allUsers"
    | "AccessControl/UserRole/retract/userInvitationsCreatedByCurrentUser"
    | "AccessControl/UserRole/retractAll/allUsers"
    | "AnalysisReport/clearEntries/all"
    | "AnalysisReport/clearEntries/createdByCurrentUser"
    | "AnalysisReport/clearEntries/ownedByCurrentTeam"
    | "AnalysisReport/clearEntryVerificationActions/all"
    | "AnalysisReport/clearEntryVerificationActions/createdByCurrentUser"
    | "AnalysisReport/clearEntryVerificationActions/ownedByCurrentTeam"
    | "AnalysisReport/clearEntryVerificationPredicateValues/all"
    | "AnalysisReport/clearEntryVerificationPredicateValues/createdByCurrentUser"
    | "AnalysisReport/clearEntryVerificationPredicateValues/ownedByCurrentTeam"
    | "AnalysisReport/clearProductRisks/all"
    | "AnalysisReport/clearProductRisks/createdByCurrentUser"
    | "AnalysisReport/clearProductRisks/ownedByCurrentTeam"
    | "AnalysisReport/clearProducts/all"
    | "AnalysisReport/clearProducts/createdByCurrentUser"
    | "AnalysisReport/clearProducts/ownedByCurrentTeam"
    | "AnalysisReport/clearRiskConfigurations/all"
    | "AnalysisReport/clearRiskConfigurations/createdByCurrentUser"
    | "AnalysisReport/clearRiskConfigurations/ownedByCurrentTeam"
    | "AnalysisReport/clearVerificationConfiguration/ownedByCurrentTeam"
    | "AnalysisReport/create/all"
    | "AnalysisReport/create/ownedByCurrentTeam"
    | "AnalysisReport/delete/all"
    | "AnalysisReport/delete/createdByCurrentUser"
    | "AnalysisReport/delete/ownedByCurrentTeam"
    | "AnalysisReport/generate/ownedByCurrentTeam"
    | "AnalysisReport/generateEntries/all"
    | "AnalysisReport/generateEntries/createdByCurrentUser"
    | "AnalysisReport/generateEntries/ownedByCurrentTeam"
    | "AnalysisReport/generateEntryVerificationActions/all"
    | "AnalysisReport/generateEntryVerificationActions/createdByCurrentUser"
    | "AnalysisReport/generateEntryVerificationActions/ownedByCurrentTeam"
    | "AnalysisReport/generateNeededEntryVerificationPredicateValues/all"
    | "AnalysisReport/generateNeededEntryVerificationPredicateValues/createdByCurrentUser"
    | "AnalysisReport/generateNeededEntryVerificationPredicateValues/ownedByCurrentTeam"
    | "AnalysisReport/generateNeededProductPredicateValues/all"
    | "AnalysisReport/generateNeededProductPredicateValues/createdByCurrentUser"
    | "AnalysisReport/generateNeededProductPredicateValues/ownedByCurrentTeam"
    | "AnalysisReport/generateProductRisks/all"
    | "AnalysisReport/generateProductRisks/createdByCurrentUser"
    | "AnalysisReport/generateProductRisks/ownedByCurrentTeam"
    | "AnalysisReport/selectProducts/all"
    | "AnalysisReport/selectProducts/createdByCurrentUser"
    | "AnalysisReport/selectProducts/ownedByCurrentTeam"
    | "AnalysisReport/selectRiskConfigurations/all"
    | "AnalysisReport/selectRiskConfigurations/createdByCurrentUser"
    | "AnalysisReport/selectRiskConfigurations/ownedByCurrentTeam"
    | "AnalysisReport/selectVerificationConfiguration/all"
    | "AnalysisReport/selectVerificationConfiguration/createdByCurrentUser"
    | "AnalysisReport/selectVerificationConfiguration/ownedByCurrentTeam"
    | "AnalysisReport/update/all"
    | "AnalysisReport/update/createdByCurrentUser"
    | "AnalysisReport/update/ownedByCurrentTeam"
    | "AnalysisReport/updateEntries/all"
    | "AnalysisReport/updateEntries/createdByCurrentUser"
    | "AnalysisReport/updateEntries/ownedByCurrentTeam"
    | "AnalysisReport/verifyEntriesHaveNeededVerificationPredicateValues/all"
    | "AnalysisReport/verifyEntriesHaveNeededVerificationPredicateValues/createdByCurrentUser"
    | "AnalysisReport/verifyEntriesHaveNeededVerificationPredicateValues/ownedByCurrentTeam"
    | "AnalysisReport/verifyProductRiskValues/all"
    | "AnalysisReport/verifyProductRiskValues/createdByCurrentUser"
    | "AnalysisReport/verifyProductRiskValues/ownedByCurrentTeam"
    | "AnalysisReport/verifyProductsHaveNeededPredicateValues/all"
    | "AnalysisReport/verifyProductsHaveNeededPredicateValues/createdByCurrentUser"
    | "AnalysisReport/verifyProductsHaveNeededPredicateValues/ownedByCurrentTeam"
    | "AnalysisReport/verifyProductsHaveProductCategories/all"
    | "AnalysisReport/verifyProductsHaveProductCategories/createdByCurrentUser"
    | "AnalysisReport/verifyProductsHaveProductCategories/ownedByCurrentTeam"
    | "AnalysisReport/verifyProductsHaveSupplierBranches/all"
    | "AnalysisReport/verifyProductsHaveSupplierBranches/createdByCurrentUser"
    | "AnalysisReport/verifyProductsHaveSupplierBranches/ownedByCurrentTeam"
    | "AnalysisReport/view/all"
    | "AnalysisReport/view/createdByCurrentUser"
    | "AnalysisReport/view/ownedByCurrentTeam"
    | "AnalysisReportEntry/delete/all"
    | "AnalysisReportEntry/delete/belongsToAnalysisReportOwnedByCurrentTeam"
    | "AnalysisReportEntry/update/all"
    | "AnalysisReportEntry/update/belongsToAnalysisReportOwnedByCurrentTeam"
    | "AnalysisReportEntry/view/all"
    | "AnalysisReportEntry/view/belongsToAnalysisReportOwnedByCurrentTeam"
    | "AnalysisReportEntryProbabilityOverwriteEvent/view/all"
    | "AnalysisReportEntryProbabilityOverwriteEvent/view/belongsToAnalysisReportOwnedByCurrentTeam"
    | "AnalysisReportEntrySeverityOverwriteEvent/view/all"
    | "AnalysisReportEntrySeverityOverwriteEvent/view/belongsToAnalysisReportOwnedByCurrentTeam"
    | "AnalysisReportProductRisk/update/all"
    | "AnalysisReportProductRisk/update/belongsToAnalysisReportOwnedByCurrentTeam"
    | "AnalysisReportProductRisk/view/all"
    | "AnalysisReportProductRisk/view/belongsToAnalysisReportOwnedByCurrentTeam"
    | "Auth/impersonateTeam/all"
    | "Auth/impersonateUser/all"
    | "Comment/view/all"
    | "Company/create/all"
    | "Company/delete/all"
    | "Company/forceDelete/all"
    | "Company/restore/all"
    | "Company/update/all"
    | "Company/update/ofCurrentTeam"
    | "Company/view/all"
    | "Company/view/ofCurrentTeam"
    | "Contact/create/all"
    | "Contact/delete/all"
    | "Contact/delete/createdByCurrentUser"
    | "Contact/forceDelete/all"
    | "Contact/restore/all"
    | "Contact/update/all"
    | "Contact/update/createdByCurrentUser"
    | "Contact/view/all"
    | "Contact/view/createdByCurrentUser"
    | "Contact/viewEmail/all"
    | "InputFile/upload/all"
    | "Job/cancel/all"
    | "Job/cancel/ownedByCurrentTeam"
    | "Job/cancel/ownedByCurrentUser"
    | "Job/create/all"
    | "Job/delete/all"
    | "Job/delete/ownedByCurrentTeam"
    | "Job/delete/ownedByCurrentUser"
    | "Job/downloadFiles/all"
    | "Job/downloadFiles/ownedByCurrentTeam"
    | "Job/downloadFiles/ownedByCurrentUser"
    | "Job/enqueue/all"
    | "Job/enqueue/ownedByCurrentTeam"
    | "Job/enqueue/ownedByCurrentUser"
    | "Job/fail/all"
    | "Job/finish/all"
    | "Job/forceDelete/all"
    | "Job/forceDelete/ownedByCurrentTeam"
    | "Job/forceDelete/ownedByCurrentUser"
    | "Job/restore/all"
    | "Job/restore/ownedByCurrentTeam"
    | "Job/restore/ownedByCurrentUser"
    | "Job/start/all"
    | "Job/update/all"
    | "Job/update/ownedByCurrentTeam"
    | "Job/update/ownedByCurrentUser"
    | "Job/view/all"
    | "Job/view/ownedByCurrentTeam"
    | "Job/view/ownedByCurrentUser"
    | "Job/viewFiles/all"
    | "Job/viewFiles/ownedByCurrentTeam"
    | "Job/viewFiles/ownedByCurrentUser"
    | "Product/activate/all"
    | "Product/activate/ownedByCurrentTeam"
    | "Product/attachTag/all"
    | "Product/attachTag/ownedByCurrentTeam"
    | "Product/create/all"
    | "Product/create/ownedByCurrentTeam"
    | "Product/deactivate/all"
    | "Product/deactivate/ownedByCurrentTeam"
    | "Product/delete/all"
    | "Product/delete/ownedByCurrentTeam"
    | "Product/detachTag/all"
    | "Product/detachTag/ownedByCurrentTeam"
    | "Product/forceDelete/all"
    | "Product/forceDelete/ownedByCurrentTeam"
    | "Product/restore/all"
    | "Product/restore/ownedByCurrentTeam"
    | "Product/update/all"
    | "Product/update/ownedByCurrentTeam"
    | "Product/view/all"
    | "Product/view/ownedByCurrentTeam"
    | "Product/viewTags/all"
    | "Product/viewTags/ownedByCurrentTeam"
    | "ProductCategory/activate/all"
    | "ProductCategory/activate/createdByCurrentUser"
    | "ProductCategory/activate/ownedByCommonGinoTeam"
    | "ProductCategory/activate/ownedByCurrentTeam"
    | "ProductCategory/create/all"
    | "ProductCategory/create/ownedByCommonGinoTeam"
    | "ProductCategory/create/ownedByCurrentTeam"
    | "ProductCategory/deactivate/all"
    | "ProductCategory/deactivate/createdByCurrentUser"
    | "ProductCategory/deactivate/ownedByCommonGinoTeam"
    | "ProductCategory/deactivate/ownedByCurrentTeam"
    | "ProductCategory/delete/all"
    | "ProductCategory/delete/ownedByCommonGinoTeam"
    | "ProductCategory/delete/ownedByCurrentTeam"
    | "ProductCategory/forceDelete/all"
    | "ProductCategory/forceDelete/ownedByCommonGinoTeam"
    | "ProductCategory/forceDelete/ownedByCurrentTeam"
    | "ProductCategory/inspectNestedSet"
    | "ProductCategory/repairNestedSet"
    | "ProductCategory/restore/all"
    | "ProductCategory/restore/deletedByCurrentUser"
    | "ProductCategory/restore/ownedByCommonGinoTeam"
    | "ProductCategory/restore/ownedByCurrentTeam"
    | "ProductCategory/update/all"
    | "ProductCategory/update/createdByCurrentUser"
    | "ProductCategory/update/ownedByCommonGinoTeam"
    | "ProductCategory/update/ownedByCurrentTeam"
    | "ProductCategory/view/all"
    | "ProductCategory/view/ownedByCommonGinoTeam"
    | "ProductCategory/view/ownedByCurrentTeam"
    | "Quantity/create/all"
    | "Quantity/delete/all"
    | "Quantity/forceDelete/all"
    | "Quantity/restore/all"
    | "Quantity/update/all"
    | "QuestionPredicate/create/all"
    | "QuestionPredicate/create/ownedByCommonGinoTeam"
    | "QuestionPredicate/create/ownedByCurrentTeam"
    | "QuestionPredicate/delete/all"
    | "QuestionPredicate/delete/ownedByCommonGinoTeam"
    | "QuestionPredicate/delete/ownedByCurrentTeam"
    | "QuestionPredicate/forceDelete/all"
    | "QuestionPredicate/restore/all"
    | "QuestionPredicate/update/all"
    | "QuestionPredicate/update/ownedByCommonGinoTeam"
    | "QuestionPredicate/update/ownedByCurrentTeam"
    | "QuestionPredicate/view/all"
    | "QuestionPredicate/view/ownedByCommonGinoTeam"
    | "QuestionPredicate/view/ownedByCurrentTeam"
    | "Reference/create/all"
    | "Reference/delete/all"
    | "Reference/forceDelete/all"
    | "Reference/restore/all"
    | "Reference/update/all"
    | "Reference/view/all"
    | "Region/create/all"
    | "Region/delete/all"
    | "Region/forceDelete/all"
    | "Region/restore/all"
    | "Region/update/all"
    | "Region/view/all"
    | "Risk/create/all"
    | "Risk/create/ownedByCommonGinoTeam"
    | "Risk/create/ownedByCurrentTeam"
    | "Risk/delete/all"
    | "Risk/delete/ownedByCommonGinoTeam"
    | "Risk/delete/ownedByCurrentTeam"
    | "Risk/forceDelete/all"
    | "Risk/restore/all"
    | "Risk/update/all"
    | "Risk/update/ownedByCommonGinoTeam"
    | "Risk/update/ownedByCurrentTeam"
    | "Risk/view/all"
    | "Risk/view/ownedByCommonGinoTeam"
    | "Risk/view/ownedByCurrentTeam"
    | "RiskColumn/create/all"
    | "RiskColumn/create/ownedByCommonGinoTeam"
    | "RiskColumn/create/ownedByCurrentTeam"
    | "RiskColumn/delete/all"
    | "RiskColumn/delete/ownedByCommonGinoTeam"
    | "RiskColumn/delete/ownedByCurrentTeam"
    | "RiskColumn/update/all"
    | "RiskColumn/update/ownedByCommonGinoTeam"
    | "RiskColumn/update/ownedByCurrentTeam"
    | "RiskColumn/updateRiskValue/all"
    | "RiskColumn/updateRiskValue/ownedByCommonGinoTeam"
    | "RiskColumn/updateRiskValue/ownedByCurrentTeam"
    | "RiskColumn/view/all"
    | "RiskColumn/view/ownedByCommonGinoTeam"
    | "RiskColumn/view/ownedByCurrentTeam"
    | "RiskColumn/view/public"
    | "RiskConfiguration/create/all"
    | "RiskConfiguration/create/ownedByCommonGinoTeam"
    | "RiskConfiguration/create/ownedByCurrentTeam"
    | "RiskConfiguration/delete/all"
    | "RiskConfiguration/delete/ownedByCommonGinoTeam"
    | "RiskConfiguration/delete/ownedByCurrentTeam"
    | "RiskConfiguration/forceDelete/all"
    | "RiskConfiguration/restore/all"
    | "RiskConfiguration/restore/ownedByCommonGinoTeam"
    | "RiskConfiguration/restore/ownedByCurrentTeam"
    | "RiskConfiguration/update/all"
    | "RiskConfiguration/update/ownedByCommonGinoTeam"
    | "RiskConfiguration/update/ownedByCurrentTeam"
    | "RiskConfiguration/view/all"
    | "RiskConfiguration/view/ownedByCommonGinoTeam"
    | "RiskConfiguration/view/ownedByCurrentTeam"
    | "Supplier/activate/all"
    | "Supplier/activate/ownedByCurrentTeam"
    | "Supplier/addSupplierBranch/all"
    | "Supplier/addSupplierBranch/ownedByCurrentTeam"
    | "Supplier/create/all"
    | "Supplier/create/ownedByCurrentTeam"
    | "Supplier/deactivate/all"
    | "Supplier/deactivate/ownedByCurrentTeam"
    | "Supplier/delete/all"
    | "Supplier/delete/ownedByCurrentTeam"
    | "Supplier/forceDelete/all"
    | "Supplier/forceDelete/ownedByCurrentTeam"
    | "Supplier/restore/all"
    | "Supplier/restore/ownedByCurrentTeam"
    | "Supplier/update/all"
    | "Supplier/update/ownedByCurrentTeam"
    | "Supplier/view/all"
    | "Supplier/view/ownedByCurrentTeam"
    | "SupplierBranch/activate/all"
    | "SupplierBranch/activate/ownedByCurrentTeam"
    | "SupplierBranch/deactivate/all"
    | "SupplierBranch/deactivate/ownedByCurrentTeam"
    | "SupplierBranch/delete/all"
    | "SupplierBranch/delete/ownedByCurrentTeam"
    | "SupplierBranch/forceDelete/all"
    | "SupplierBranch/restore/all"
    | "SupplierBranch/update/all"
    | "SupplierBranch/update/ownedByCurrentTeam"
    | "SupplierBranch/view/all"
    | "SupplierBranch/view/ownedByCurrentTeam"
    | "Tag/view/all"
    | "Tag/view/createdByCurrentUser"
    | "Tag/view/ownedByCurrentTeam"
    | "Tag/view/ownedByCommonGinoTeam"
    | "Tag/view/ownedByCommonFlgTeam"
    | "Tag/view/ownedByCommonAdminTeam"
    | "Tag/view/ownedByCommonDevTeam"
    | "Tag/view/ownedBySystemTeam"
    | "Tag/create/all"
    | "Tag/create/createdByCurrentUser"
    | "Tag/create/ownedByCurrentTeam"
    | "Tag/create/ownedByCommonGinoTeam"
    | "Tag/create/ownedByCommonFlgTeam"
    | "Tag/create/ownedByCommonAdminTeam"
    | "Tag/create/ownedByCommonDevTeam"
    | "Tag/create/ownedBySystemTeam"
    | "Tag/update/all"
    | "Tag/update/createdByCurrentUser"
    | "Tag/update/ownedByCurrentTeam"
    | "Tag/update/ownedByCommonGinoTeam"
    | "Tag/update/ownedByCommonFlgTeam"
    | "Tag/update/ownedByCommonAdminTeam"
    | "Tag/update/ownedByCommonDevTeam"
    | "Tag/update/ownedBySystemTeam"
    | "Tag/delete/all"
    | "Tag/delete/createdByCurrentUser"
    | "Tag/delete/ownedByCurrentTeam"
    | "Tag/delete/ownedByCommonGinoTeam"
    | "Tag/delete/ownedByCommonFlgTeam"
    | "Tag/delete/ownedByCommonAdminTeam"
    | "Tag/delete/ownedByCommonDevTeam"
    | "Tag/delete/ownedBySystemTeam"
    | "Tag/attach/all"
    | "Tag/attach/createdByCurrentUser"
    | "Tag/attach/ownedByCurrentTeam"
    | "Tag/attach/ownedByCommonGinoTeam"
    | "Tag/attach/ownedByCommonFlgTeam"
    | "Tag/attach/ownedByCommonAdminTeam"
    | "Tag/attach/ownedByCommonDevTeam"
    | "Tag/attach/ownedBySystemTeam"
    | "Tag/detach/all"
    | "Tag/detach/createdByCurrentUser"
    | "Tag/detach/ownedByCurrentTeam"
    | "Tag/detach/ownedByCommonGinoTeam"
    | "Tag/detach/ownedByCommonFlgTeam"
    | "Tag/detach/ownedByCommonAdminTeam"
    | "Tag/detach/ownedByCommonDevTeam"
    | "Tag/detach/ownedBySystemTeam"
    | "Team/attachTag/all"
    | "Team/create/all"
    | "Team/delete/all"
    | "Team/detachTag/all"
    | "Team/forceDelete/all"
    | "Team/list"
    | "Team/restore/all"
    | "Team/update/all"
    | "Team/update/currentTeam"
    | "Team/view/all"
    | "Team/view/assignedToCurrentUser"
    | "Team/view/commonAdminTeam"
    | "Team/view/commonDevTeam"
    | "Team/view/commonFlgTeam"
    | "Team/view/commonGinoTeam"
    | "Team/view/currentTeam"
    | "Team/view/systemTeam"
    | "Team/viewTags/all"
    | "Threat/activate/all"
    | "Threat/activate/ownedByCommonGinoTeam"
    | "Threat/activate/ownedByCurrentTeam"
    | "Threat/addRisk/all"
    | "Threat/addRisk/ownedByCommonGinoTeam"
    | "Threat/addRisk/ownedByCurrentTeam"
    | "Threat/create/all"
    | "Threat/create/ownedByCommonGinoTeam"
    | "Threat/create/ownedByCurrentTeam"
    | "Threat/deactivate/all"
    | "Threat/deactivate/ownedByCommonGinoTeam"
    | "Threat/deactivate/ownedByCurrentTeam"
    | "Threat/delete/all"
    | "Threat/delete/ownedByCommonGinoTeam"
    | "Threat/delete/ownedByCurrentTeam"
    | "Threat/forceDelete/all"
    | "Threat/restore/all"
    | "Threat/update/all"
    | "Threat/update/ownedByCommonGinoTeam"
    | "Threat/update/ownedByCurrentTeam"
    | "Threat/view/all"
    | "Threat/view/ownedByCommonGinoTeam"
    | "Threat/view/ownedByCurrentTeam"
    | "ThreatCategory/activate/all"
    | "ThreatCategory/activate/ownedByCommonGinoTeam"
    | "ThreatCategory/activate/ownedByCurrentTeam"
    | "ThreatCategory/addThreat/all"
    | "ThreatCategory/addThreat/ownedByCommonGinoTeam"
    | "ThreatCategory/addThreat/ownedByCurrentTeam"
    | "ThreatCategory/create/all"
    | "ThreatCategory/create/ownedByCommonGinoTeam"
    | "ThreatCategory/create/ownedByCurrentTeam"
    | "ThreatCategory/deactivate/all"
    | "ThreatCategory/deactivate/ownedByCommonGinoTeam"
    | "ThreatCategory/deactivate/ownedByCurrentTeam"
    | "ThreatCategory/delete/all"
    | "ThreatCategory/delete/ownedByCommonGinoTeam"
    | "ThreatCategory/delete/ownedByCurrentTeam"
    | "ThreatCategory/forceDelete/all"
    | "ThreatCategory/forceDelete/ownedByCommonGinoTeam"
    | "ThreatCategory/forceDelete/ownedByCurrentTeam"
    | "ThreatCategory/inspectNestedSet"
    | "ThreatCategory/removeThreat/all"
    | "ThreatCategory/removeThreat/ownedByCommonGinoTeam"
    | "ThreatCategory/removeThreat/ownedByCurrentTeam"
    | "ThreatCategory/repairNestedSet"
    | "ThreatCategory/restore/all"
    | "ThreatCategory/restore/ownedByCommonGinoTeam"
    | "ThreatCategory/restore/ownedByCurrentTeam"
    | "ThreatCategory/update/all"
    | "ThreatCategory/update/ownedByCommonGinoTeam"
    | "ThreatCategory/update/ownedByCurrentTeam"
    | "ThreatCategory/view/all"
    | "ThreatCategory/view/ownedByCommonGinoTeam"
    | "ThreatCategory/view/ownedByCurrentTeam"
    | "TeamLicenseClass/create/all"
    | "TeamLicenseClass/delete/all"
    | "TeamLicenseClass/update/all"
    | "TeamLicenseClass/view/all"
    | "TeamLicense/activate/all"
    | "TeamLicense/create/all"
    | "TeamLicense/deactivate/all"
    | "TeamLicense/delete/all"
    | "TeamLicense/update/all"
    | "TeamLicense/view/all"
    | "TeamLicense/view/ownedByCurrentTeam"
    | "Unit/create/all"
    | "Unit/delete/all"
    | "Unit/forceDelete/all"
    | "Unit/restore/all"
    | "Unit/update/all"
    | "User/delete/all"
    | "User/view/all"
    | "User/view/currentUser"
    | "User/view/withRoleInCurrentTeam"
    | "User/viewAuthInfo/all"
    | "User/viewAuthInfo/currentUser"
    | "User/viewAuthInfo/withRoleInCurrentTeam"
    | "User/viewContactInfo/all"
    | "User/viewContactInfo/currentUser"
    | "User/viewContactInfo/withRoleInCurrentTeam"
    | "User/viewPersonalSettings/all"
    | "User/viewPersonalSettings/currentUser"
    | "User/viewPersonalSettings/withRoleInCurrentTeam"
    | "User/viewUserRoles/all"
    | "UserInvitation/cancel/all"
    | "UserInvitation/cancel/createdByCurrentUser"
    | "UserInvitation/create/all"
    | "UserInvitation/delete/all"
    | "UserInvitation/delete/createdByCurrentUser"
    | "UserInvitation/forceDelete/all"
    | "UserInvitation/restore/all"
    | "UserInvitation/send/all"
    | "UserInvitation/send/createdByCurrentUser"
    | "UserInvitation/update/all"
    | "UserInvitation/update/createdByCurrentUser"
    | "UserInvitation/view/all"
    | "UserInvitation/view/createdByCurrentUser"
    | "UserInvitation/viewToEmail/all"
    | "UserInvitation/viewToEmail/createdByCurrentUser"
    | "VerificationAction/activate/all"
    | "VerificationAction/activate/ownedByCommonGinoTeam"
    | "VerificationAction/activate/ownedByCurrentTeam"
    | "VerificationAction/create/all"
    | "VerificationAction/create/ownedByCommonGinoTeam"
    | "VerificationAction/create/ownedByCurrentTeam"
    | "VerificationAction/deactivate/all"
    | "VerificationAction/deactivate/ownedByCommonGinoTeam"
    | "VerificationAction/deactivate/ownedByCurrentTeam"
    | "VerificationAction/delete/all"
    | "VerificationAction/delete/ownedByCommonGinoTeam"
    | "VerificationAction/delete/ownedByCurrentTeam"
    | "VerificationAction/forceDelete/all"
    | "VerificationAction/forceDelete/ownedByCommonGinoTeam"
    | "VerificationAction/forceDelete/ownedByCurrentTeam"
    | "VerificationAction/restore/all"
    | "VerificationAction/restore/ownedByCommonGinoTeam"
    | "VerificationAction/restore/ownedByCurrentTeam"
    | "VerificationAction/update/all"
    | "VerificationAction/update/ownedByCommonGinoTeam"
    | "VerificationAction/update/ownedByCurrentTeam"
    | "VerificationAction/view/all"
    | "VerificationAction/view/ownedByCommonGinoTeam"
    | "VerificationAction/view/ownedByCurrentTeam"
    | "VerificationConfiguration/activate/all"
    | "VerificationConfiguration/activate/ownedByCommonGinoTeam"
    | "VerificationConfiguration/activate/ownedByCurrentTeam"
    | "VerificationConfiguration/create/all"
    | "VerificationConfiguration/create/ownedByCommonGinoTeam"
    | "VerificationConfiguration/create/ownedByCurrentTeam"
    | "VerificationConfiguration/deactivate/all"
    | "VerificationConfiguration/deactivate/ownedByCommonGinoTeam"
    | "VerificationConfiguration/deactivate/ownedByCurrentTeam"
    | "VerificationConfiguration/delete/all"
    | "VerificationConfiguration/delete/ownedByCommonGinoTeam"
    | "VerificationConfiguration/delete/ownedByCurrentTeam"
    | "VerificationConfiguration/forceDelete/all"
    | "VerificationConfiguration/forceDelete/ownedByCommonGinoTeam"
    | "VerificationConfiguration/forceDelete/ownedByCurrentTeam"
    | "VerificationConfiguration/restore/all"
    | "VerificationConfiguration/restore/ownedByCommonGinoTeam"
    | "VerificationConfiguration/restore/ownedByCurrentTeam"
    | "VerificationConfiguration/update/all"
    | "VerificationConfiguration/update/ownedByCommonGinoTeam"
    | "VerificationConfiguration/update/ownedByCurrentTeam"
    | "VerificationConfiguration/view/all"
    | "VerificationConfiguration/view/ownedByCommonGinoTeam"
    | "VerificationConfiguration/view/ownedByCurrentTeam"
    | "VerificationPredicate/create/all"
    | "VerificationPredicate/create/ownedByCommonGinoTeam"
    | "VerificationPredicate/create/ownedByCurrentTeam"
    | "VerificationPredicate/delete/all"
    | "VerificationPredicate/delete/ownedByCommonGinoTeam"
    | "VerificationPredicate/delete/ownedByCurrentTeam"
    | "VerificationPredicate/forceDelete/all"
    | "VerificationPredicate/forceDelete/ownedByCommonGinoTeam"
    | "VerificationPredicate/forceDelete/ownedByCurrentTeam"
    | "VerificationPredicate/restore/all"
    | "VerificationPredicate/restore/ownedByCommonGinoTeam"
    | "VerificationPredicate/restore/ownedByCurrentTeam"
    | "VerificationPredicate/update/all"
    | "VerificationPredicate/update/ownedByCommonGinoTeam"
    | "VerificationPredicate/update/ownedByCurrentTeam"
    | "VerificationPredicate/view/all"
    | "VerificationPredicate/view/ownedByCommonGinoTeam"
    | "VerificationPredicate/view/ownedByCurrentTeam"
    | "Audit/viewIpAddress/all"
    | "Audit/viewIpAddress/createdByCurrentTeam"
    | "Audit/viewIpAddress/createdByCurrentUser"
    | "Audit/viewUserAgent/all"
    | "Audit/viewUserAgent/createdByCurrentTeam"
    | "Audit/viewUserAgent/createdByCurrentUser"
    | "GeneralAudit/view/all"
    | "GeneralAudit/view/createdByCurrentTeam"
    | "GeneralAudit/view/createdByCurrentUser"
    | "ProductCategoryAudit/view/all"
    | "ProductCategoryAudit/view/createdByCurrentUser"
    | "ProductCategoryAudit/view/createdByCurrentTeam"
    | "ProductCategoryAudit/view/ownedByCommonGinoTeam"
    | "ProductCategoryAudit/view/ownedByCommonFlgTeam"
    | "ProductCategoryAudit/view/ownedByCurrentTeam"
    | "RiskAudit/view/all"
    | "RiskAudit/view/createdByCurrentUser"
    | "RiskAudit/view/createdByCurrentTeam"
    | "RiskAudit/view/ownedByCommonGinoTeam"
    | "RiskAudit/view/ownedByCommonFlgTeam"
    | "RiskAudit/view/ownedByCurrentTeam"
    | "RiskProbabilityAudit/view/all"
    | "RiskProbabilityAudit/view/createdByCurrentUser"
    | "RiskProbabilityAudit/view/createdByCurrentTeam"
    | "RiskProbabilityAudit/view/ownedByCommonGinoTeam"
    | "RiskProbabilityAudit/view/ownedByCommonFlgTeam"
    | "RiskProbabilityAudit/view/ownedByCurrentTeam"
    | "ThreatAudit/view/all"
    | "ThreatAudit/view/createdByCurrentUser"
    | "ThreatAudit/view/createdByCurrentTeam"
    | "ThreatAudit/view/ownedByCommonGinoTeam"
    | "ThreatAudit/view/ownedByCommonFlgTeam"
    | "ThreatAudit/view/ownedByCurrentTeam"
    | "ThreatCategoryAudit/view/all"
    | "ThreatCategoryAudit/view/createdByCurrentUser"
    | "ThreatCategoryAudit/view/createdByCurrentTeam"
    | "ThreatCategoryAudit/view/ownedByCommonGinoTeam"
    | "ThreatCategoryAudit/view/ownedByCommonFlgTeam"
    | "ThreatCategoryAudit/view/ownedByCurrentTeam"
    | "ThreatSeverityAudit/view/all"
    | "ThreatSeverityAudit/view/createdByCurrentUser"
    | "ThreatSeverityAudit/view/createdByCurrentTeam"
    | "ThreatSeverityAudit/view/ownedByCommonGinoTeam"
    | "ThreatSeverityAudit/view/ownedByCommonFlgTeam"
    | "ThreatSeverityAudit/view/ownedByCurrentTeam"
    | "Backend/DevTools/view/all"
    | "Backend/DevTools/view/inNonProductionEnvironments"
    | "BackendMaintenance/clearAllCaches"
    | "BackendMaintenance/clearBackgroundQueues"
    | "BackendMaintenance/manageBackgroundQueues"
    | "BackendMaintenance/rebuildSearchIndexes"
    | "BackendMaintenance/refreshHealth"
    | "BackendMaintenance/viewHealthDetails"
    | "BackendMaintenance/viewServerState"
    | "BackendMaintenance/viewServerStats";


export enum Role {
    JOB_WORKER = "JOB_WORKER",
    SYSTEM_EXPORT_APP = "SYSTEM_EXPORT_APP",
    TEST_DATA_SEEDER = "TEST_DATA_SEEDER",
    TEST_EXECUTOR = "TEST_EXECUTOR",
    USER_EXPORT_APP = "USER_EXPORT_APP",
    USER_IMPORT_APP = "USER_IMPORT_APP",
    CS = "CS",
    INK = "INK",
    KV = "KV",
    TEAM_ADMIN = "TEAM_ADMIN",
    TEAM_GUEST = "TEAM_GUEST",
    TEAM_READER = "TEAM_READER",
    team = "team",
    ACCESS_ADMIN = "ACCESS_ADMIN",
    COM = "COM",
    DEV = "DEV",
    EDITOR = "EDITOR",
    MAINTAINER = "MAINTAINER",
    PO = "PO",
    READER = "READER",
    SUPER = "SUPER",
    user = "user"
}


export enum ExplicitRole {
    JOB_WORKER = "JOB_WORKER",
    SYSTEM_EXPORT_APP = "SYSTEM_EXPORT_APP",
    TEST_DATA_SEEDER = "TEST_DATA_SEEDER",
    TEST_EXECUTOR = "TEST_EXECUTOR",
    USER_EXPORT_APP = "USER_EXPORT_APP",
    USER_IMPORT_APP = "USER_IMPORT_APP",
    CS = "CS",
    INK = "INK",
    KV = "KV",
    TEAM_ADMIN = "TEAM_ADMIN",
    TEAM_GUEST = "TEAM_GUEST",
    TEAM_READER = "TEAM_READER",
    ACCESS_ADMIN = "ACCESS_ADMIN",
    COM = "COM",
    DEV = "DEV",
    EDITOR = "EDITOR",
    MAINTAINER = "MAINTAINER",
    PO = "PO",
    READER = "READER",
    SUPER = "SUPER"
}


export enum ImplicitRole {
    team = "team",
    user = "user"
}


export enum ClientRole {
    JOB_WORKER = "JOB_WORKER",
    SYSTEM_EXPORT_APP = "SYSTEM_EXPORT_APP",
    TEST_DATA_SEEDER = "TEST_DATA_SEEDER",
    TEST_EXECUTOR = "TEST_EXECUTOR",
    USER_EXPORT_APP = "USER_EXPORT_APP",
    USER_IMPORT_APP = "USER_IMPORT_APP"
}


export enum ExplicitClientRole {
    JOB_WORKER = "JOB_WORKER",
    SYSTEM_EXPORT_APP = "SYSTEM_EXPORT_APP",
    TEST_DATA_SEEDER = "TEST_DATA_SEEDER",
    TEST_EXECUTOR = "TEST_EXECUTOR",
    USER_EXPORT_APP = "USER_EXPORT_APP",
    USER_IMPORT_APP = "USER_IMPORT_APP"
}


export enum UserRole {
    ACCESS_ADMIN = "ACCESS_ADMIN",
    COM = "COM",
    DEV = "DEV",
    EDITOR = "EDITOR",
    MAINTAINER = "MAINTAINER",
    PO = "PO",
    READER = "READER",
    SUPER = "SUPER",
    user = "user"
}


export enum ExplicitUserRole {
    ACCESS_ADMIN = "ACCESS_ADMIN",
    COM = "COM",
    DEV = "DEV",
    EDITOR = "EDITOR",
    MAINTAINER = "MAINTAINER",
    PO = "PO",
    READER = "READER",
    SUPER = "SUPER"
}


export enum SuperUserRole {
    SUPER = "SUPER"
}


export enum TeamRole {
    CS = "CS",
    INK = "INK",
    KV = "KV",
    TEAM_ADMIN = "TEAM_ADMIN",
    TEAM_GUEST = "TEAM_GUEST",
    TEAM_READER = "TEAM_READER",
    team = "team"
}


export enum ExplicitTeamRole {
    CS = "CS",
    INK = "INK",
    KV = "KV",
    TEAM_ADMIN = "TEAM_ADMIN",
    TEAM_GUEST = "TEAM_GUEST",
    TEAM_READER = "TEAM_READER"
}


